// components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../images/Logo_no_bg.webp';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-col">
              <div className="footer-logo">
                <img src={logo} alt="ATC" style={{ width: '140px' }} />
                <p>{t('text_footer_sous_logo')}</p>
                <div className="footer-social">
                  <a href="https://www.facebook.com/profile.php?id=100080652765508" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="https://www.instagram.com/atchhub237?igsi=ejB6c2tiZHl3MnAw" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/118613966/admin/dashboard/" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="https://www.tiktok.com/@atc_hub_techpreneuriat?_r=1&_t=ZS-99QD1gHuP3d" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-tiktok"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="footer-col">
              <h3>Support 24/7</h3>
              <ul>
                <li><Link to="/privacy">{t('politiq_confidential')}</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
                <li><Link to="/terms">{t('condition_general')}</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li><Link to="/history">{t('histoire')}</Link></li>
              </ul>
            </div>
            <div className="footer-col">
              <h3>{t('titre_adresse_local')}</h3>
              <p>{t('msg_adresse_local')}</p>
              <div className="footer-address">
                <div className="address-item">
                  <i className="fas fa-map-marker-alt"></i>
                  <span>{t('titre_adresse')} {t('adresse')}</span>
                </div>
                <div className="address-item">
                  <i className="fas fa-phone"></i>
                  <span>Phone: +237 696 801 921</span>
                </div>
                <div className="address-item">
                  <i className="fab fa-whatsapp"></i>
                  <a href="https://wa.me/33668383331" style={{color:'rgba(255,255,255,0.7)'}} target="_blank" rel="noopener noreferrer"
>whatsapp: +33 668 383 331</a>
                </div>
                <div className="address-item">
                  <i className="fas fa-envelope"></i>
                  <span>contact@atchubs.com</span>
                </div>
              </div>
            </div>
            <div className="footer-col">
              <h3>{t('titre_horaire')}</h3>
              <div className="working-hours">
                <div className="hour-item">
                  <span>{t('horaire_semaine')}</span>
                  <span>08:00 - 17:00</span>
                </div>
                <div className="hour-item emergency">
                  <span>{t('horaire_urgence')}</span>
                  <span> : (+237) 681 134 804</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>Copyright &copy; {t('all_reserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;